import { BannerSection, AboutTech, DevelopersSection, ProjectsSection, Footer } from 'sections';

function Home() {
  return (
    <>
      <BannerSection />
      <main>
        <AboutTech />
        <ProjectsSection />
        <DevelopersSection />
        <Footer />
      </main>
    </>
  );
}

export default Home;
